/** Slide a square RGBA terrain cache on its fixed world lattice. Only newly
 * exposed rows/columns need procedural samples. Source and target are distinct. */
export function fillDepthWindow(target: Uint8Array, previous: Uint8Array, side: number,
  dx: number, dy: number, sample: (x: number, y: number) => number,
  shelter?: (x:number,y:number)=>number): number {
  const reusable = Number.isInteger(dx) && Number.isInteger(dy) && Math.abs(dx) < side && Math.abs(dy) < side;
  let sampled = 0;
  for (let y = 0; y < side; y++) for (let x = 0; x < side; x++) {
    const index = (y * side + x) * 4, sx = x + dx, sy = y + dy;
    if (reusable && sx >= 0 && sx < side && sy >= 0 && sy < side) {
      target[index] = previous[(sy * side + sx) * 4];
      target[index+1]=shelter?previous[(sy * side + sx)*4+1]:0;
    } else { target[index] = sample(x, y);target[index+1]=shelter?shelter(x,y):0; sampled++; }
    target[index + 2] = 0;
    target[index + 3] = 255;
  }
  return sampled;
}
